<template>
    <Row type="none" class="bg-white rounded shadow min-h-screen">

        <div class="grid grid-cols-12 py-4 container">
            <div class="col-span-12 md:col-span-3">
                <button
                    class="h-11 w-44 rounded bg-main hover:bg-hoverMain focus:ring-0 z-40 text-white font-bold border-0"
                    @click="$i18nHelper.toUrl('incomeAndOutcomeCategory/add')"
                >
                    {{ $t('add') }}
                </button>
            </div>
            <div class="col-span-12 lg:col-start-9 lg:col-span-4 mt-2 lg:mt-0 relative">
                <img src="/images/search-interface-symbol.png" alt="" @click="searchFilters" class="h-6 absolute left-2 top-2">
                <b-form-input
                    class="border-gray-300 pl-10 w-full h-11 focus:ring-0"
                    v-model="search.productName"
                    :placeholder="$t('name')"
                    @input="searchFilters"
                />
            </div>
        </div>

        <table class="w-full mt-3">
            <thead>
            <tr class="bg-lightGray h-11 font-bold">
                <th class="pl-3">#</th>
                <th>{{ $t('name') }}</th>
                <th class="d-none d-sm-table-cell">{{ $t('createdAt') }}</th>
                <th class="text-center">{{ $t('supplier.type') }}</th>
                <th>{{ $t('actions') }}</th>
            </tr>
            </thead>
            <tbody
                v-for="category in getIncomeAndOutcomeCategories"
                :key="category.id"
            >
            <tr class="h-11 cursor-pointer border-bottom">
                <td class="pl-3">{{ category.id }}</td>
                <td>{{ getName(category.name) }}</td>
                <td class="d-none d-sm-table-cell">{{ dateFormat(category.createdAt) }}</td>
                <td class="pr-4">
                    <div class="rounded py-1 text-center" :style="`background-color: ${howBgColor(category.isIncome)}`">
                        <span v-if="category.isIncome">{{ $t('incomeAndOutcome.income') }}</span>
                        <span v-else>{{ $t('incomeAndOutcome.outlay') }}</span>
                    </div>
                </td>
                <td>
                    <img src="/images/edit.png" @click="$i18nHelper.toUrl('incomeAndOutcomeCategory/' + category.id)" alt="" class="h-6 pr-3">
                    <img src="/images/Union.png" @click="deleteCategory(category.id)" alt="" class="h-7">
                </td>
            </tr>
            </tbody>
        </table>
        
        <div class="row">
            <div class="col mt-4 ml-4">
                <Pagination
                    :search="search"
                    base-url="incomeAndOutcomeCategories"
                    :total-items="getIncomeAndOutcomeCategoriesTotalCount"
                    method-name="fetchIncomeAndOutcomeCategories"
                />
            </div>
        </div>
    </Row>
</template>

<script>
import currencyFormatMixin from "@/mixin/currencyFormatMixin";
import dateFormattingMixin from "@/mixin/dateFormattingMixin";
import currencyRateMixin from "@/mixin/currencyRateMixin";
import {mapActions, mapGetters} from "vuex";
import Pagination from "@/components/html/Pagination";
import companyCount from "@/store/modules/companyCount";
import Row from "@/components/html/Row.vue";

export default {
    name: "List",
    components: {
        Row,
        Pagination,
    },
    mixins: [currencyFormatMixin, dateFormattingMixin, currencyRateMixin],
    computed: {
        companyCount() {
            return companyCount
        },
        ...mapGetters([
            'getIncomeAndOutcomeCategories',
            'getIncomeAndOutcomeCategoriesTotalCount',
        ]),
    },
    data() {
        return {
            page: 1,
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'finance.title', url: 'companyCount'},
                {name: 'category'},
            ],
            options: [
                {text: this.$t('filter.all'), value: null},
                {text: this.$t('incomeAndOutcome.income'), value: true},
                {text: this.$t('incomeAndOutcome.outlay'), value: false}
            ],
            search: {
                page: 1,
                name: null,
            },
        }
    },
    methods: {
        ...mapActions([
            'fetchIncomeAndOutcomeCategories',
            'deleteIncomeAndOutcomeCategory',
            'searchIncomeAndOutcomeCategory',
            'setBreadcrumbItems'
        ]),
        getName(categoryName) {
            switch (categoryName) {
                case "sale":
                case "purchase":
                case "rent":
                case "salary":
                case "communal":
                case "debt":
                case "credit":
                case "paymentSystem":
                    return this.$t("finance.income." + categoryName)

                default:
                    return categoryName
            }
        },
        deleteCategory(id) {
            this.$root.showOverlay = true
            this.deleteIncomeAndOutcomeCategory(id)
                .then(() => {
                    this.$i18nHelper.flash(this.$t('finance.deleteInfo'), 'success')
                    this.fetchIncomeAndOutcomeCategories(this.search)
                })

            this.$root.showOverlay = false
        },
        searchFilters() {
            this.$root.showOverlay = true
            this.searchIncomeAndOutcomeCategory(this.search)
                .catch((err) => {
                    console.log(err)
                })
                .finally(() => {
                    this.$root.showOverlay = false
                });
        },
        resetProductPurchaseSearchInfo() {
            Object.assign(this.$data, this.$options.data.call(this));
            this.searchFilters()
        },
        howBgColor(isIncome) {
            return isIncome ? '#D4F8E5' : '#FFCDB8'
        },
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    mounted() {
        this.fetchIncomeAndOutcomeCategories(this.search)
    },
}
</script>

<style scoped>
.btn-secondary {
    background-color: #ffffff !important;
    border: none;
    padding: 0;
}
</style>